import React from 'react';
import './gallery.scss';
import { useRef, useState, useEffect } from 'react';

const Gallery = ({ galleryData1 }) => {
  const nextButton = useRef();
  const photoView = useRef();
  const descView = useRef();

  const [intervalId, setIntervalId] = useState();
  const [currentPhoto, setCurrentPhoto] = useState(galleryData1.photos[0]);

  const index = useRef(0); //tracks change of opacity of photos
  const index2 = useRef(0); //tracks photo index

  //setting up autoplay
  useEffect(() => {
    let i = index.current;
    let i2 = index2.current;
    const startSlideShow = setInterval(() => {
      //setting up photo to fade
      if (i === 0) {
        photoView.current.style.opacity = '0.1';
        descView.current.style.opacity = '0.1';
        i++;
      } else {
        if (i2 < 4) {
          i2++;
          setCurrentPhoto(galleryData1.photos[i2]);
          photoView.current.style.opacity = '1';
          descView.current.style.opacity = '1';
          //if it reaches end of photo reset to first
        } else if (i2 >= 4) {
          i2 = 0;
          setCurrentPhoto(galleryData1.photos[i2]);
          photoView.current.style.opacity = '1';
          descView.current.style.opacity = '1';
        }
        i--;
      }
    }, 3000);
    setIntervalId(startSlideShow);
    return () => window.clearInterval(intervalId);
  }, []);

  //handles next/back button: autoplay is stopped when these are clicked
  const clickHandle = (next) => {
    let index = currentPhoto.number - 1;
    window.clearInterval(intervalId);
    setIntervalId(null);

    if (photoView.current) {
      if ((photoView.current.style.opacity = '0.1')) {
        photoView.current.style.opacity = '1';
        descView.current.style.opacity = '1';
      }
      if (photoView.current.style.animation === '') {
        photoView.current.style.animation = 'photo-appear 1.5s ease-in';
        descView.current.style.animation = 'photo-appear 1.5s ease-in';
      } else if (photoView.current.style.animationName === 'photo-appear') {
        photoView.current.style.animation = 'photo-appear2 1.5s ease-in';
        descView.current.style.animation = 'photo-appear2 1.5s ease-in';
      } else if (photoView.current.style.animationName === 'photo-appear2') {
        photoView.current.style.animation = 'photo-appear 1.5s ease-in';
        descView.current.style.animation = 'photo-appear 1.5s ease-in';
      }

      if (next === 'next') {
        if (index < 4) {
          setCurrentPhoto(galleryData1.photos[index + 1]);
        } else {
          setCurrentPhoto(galleryData1.photos[0]);
        }
      } else {
        if (index > 0) {
          setCurrentPhoto(galleryData1.photos[index - 1]);
        } else {
          setCurrentPhoto(galleryData1.photos[4]);
        }
      }
    }
  };

  return (
    <section className="gallery">
      <div className="gallery__contents">
        <div className="descContainer">
          <div className="descContainer__head">
            <div className="descContainer__head__page">{currentPhoto.number} OF 5</div>
            <div className="descContainer__head__title">{currentPhoto.title}</div>
          </div>
          <div className="descContainer__description" ref={descView}>
            <p className="description--copy">{currentPhoto.desc}</p>
          </div>
          <div className="descContainer__nav">
            <button
              onClick={() => {
                clickHandle('back');
              }}
              className="descContainer__nav__buttons descContainer__head__page"
              id="back"
            >
              BACK
            </button>
            |
            <button
              onClick={() => {
                clickHandle('next');
              }}
              className="descContainer__nav__buttons descContainer__head__page"
              ref={nextButton}
              id="next"
            >
              NEXT
            </button>
          </div>
        </div>
        <div className="photoContainer">
          <picture className="photoContainer__photo" ref={photoView}>
            <source srcSet={currentPhoto.desktop} media="(min-width: 461px)" />
            <source srcSet={currentPhoto.mobile} media="(max-width: 460px)" />
            <img src={currentPhoto.desktop} alt={galleryData1.name}></img>
          </picture>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
